import {REDEEMABLE_FLAG_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapRedeemableFlagToDomainValue = (redeemableFlag?: string): DomainValueReference | null => {
  if (!redeemableFlag || !(redeemableFlag in REDEEMABLE_FLAG_TO_DV_MAPPING)) return null;

  return {$ref: REDEEMABLE_FLAG_TO_DV_MAPPING[redeemableFlag as keyof typeof REDEEMABLE_FLAG_TO_DV_MAPPING]};
};
